import { Component, ElementRef, input, viewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MODEL_YEAR_RANGE } from '../../../../core/models/vehicle.model';

@Component({
  selector: 'app-year-input',
  imports: [ReactiveFormsModule],
  templateUrl: './year-input.html',
  styleUrl: './year-input.scss',
})
export class YearInput {
  readonly control = input.required<FormControl<number | null>>();

  readonly yearRange = MODEL_YEAR_RANGE;

  private readonly yearInput = viewChild<ElementRef<HTMLInputElement>>('yearInput');

  clear(): void {
    this.control().reset();
    this.yearInput()?.nativeElement.focus();
  }
}
